import React from "react";

interface ContainerProps {
    children: React.ReactNode;
}

const Container: React.FC<ContainerProps> = ({ children }) => {
    return (
        <div className="gs-otp-page">
            <div className="gs-otp-page__center">
                <div className="gs-otp-card">
                    <div className="gs-otp-card__body">{children}</div>
                </div>
            </div>
        </div>
    );
};

export default Container;
